import React from 'react';
import styled from 'styled-components';
import { makeColorSetClass, spacer8, spacer16, spacer24, spacer32, spacer40, Type, } from '@spotify-internal/encore-web';
import { DELAYS, fadeInAnimation, ImageAspectBox21x9, withAnimationContext, Grid, ResponsiveType, ContentfulImage, TWO_COLUMN_MAX_WIDTH, } from '../../ui';
import { Quote } from './Quote';
const SingleTestimonial = styled(Grid) `
  padding-top: ${spacer24};
  padding-bottom: ${spacer40};

  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    padding-bottom: ${spacer32};
  }
`;
const ImageContainer = styled(ImageAspectBox21x9) `
  grid-column: 1 / -1;

  margin-bottom: ${spacer32};

  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    order: 2;
  }
`;
const Supertext = withAnimationContext(styled(ResponsiveType).attrs({
    typeAs: 'h3',
    variantDesktop: 'ballad',
    variantMobile: 'viola',
}) `
    ${fadeInAnimation(DELAYS.FIRST)};
    text-transform: uppercase;
    margin-bottom: ${spacer8};
  `);
const Headline = withAnimationContext(styled(ResponsiveType).attrs({
    typeAs: 'h2',
    variantDesktop: 'brio',
    variantMobile: 'alto',
}) `
    ${fadeInAnimation(DELAYS.SECOND)};
    margin-bottom: ${spacer24};
    @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
      margin-bottom: ${spacer16};
    }
  `);
const HeadlineSupertextBody = styled.div `
  grid-column: 1 / 5;

  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    grid-column: 1 / -1;
    order: 1;
  }
`;
const StyledBody = withAnimationContext(styled(Type.p).attrs({
    variant: 'ballad',
}) `
    ${fadeInAnimation(DELAYS.THIRD)};
    @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
      margin-bottom: ${spacer32};
    }
  `);
const StyledTestimonial = styled.div `
  grid-column: 6 / -1;

  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    grid-column: 1 / -1;
    order: 3;
  }
`;
export const SingleTestimonialModule = React.forwardRef(({ supertext = '', headline = '', body = '', quote = '', image, source = '', jobTitle = '', caption = '', theme = '', }, ref) => {
    const quoteProps = {
        quote,
        source,
        jobTitle,
    };
    return (React.createElement(SingleTestimonial, { ref: ref, className: makeColorSetClass(theme === 'whiteOnBlack' ? 'invertedLight' : 'invertedDark') },
        image && (React.createElement(ImageContainer, null,
            React.createElement(ContentfulImage, { asset: image, caption: caption }))),
        React.createElement(HeadlineSupertextBody, null,
            React.createElement(Supertext, null, supertext),
            React.createElement(Headline, null, headline),
            React.createElement(StyledBody, null, body)),
        React.createElement(StyledTestimonial, null,
            React.createElement(Quote, Object.assign({}, quoteProps)))));
});
//# sourceMappingURL=index.js.map